import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

// צילום אלמנט DOM לקנבס
async function captureCanvas(element, bgColor) {
  return html2canvas(element, {
    scale: 2,
    backgroundColor: bgColor,
    useCORS: true,
    logging: false,
    windowWidth: element.scrollWidth,
    windowHeight: element.scrollHeight,
  });
}

// שיתוף/הורדה של אלמנט כתמונה (PNG)
export async function shareElementAsImage(element, { filename = 'tennis-bracket.png', title = 'טניס פרו ישראל' } = {}) {
  const canvas = await captureCanvas(element, '#0b1220');
  const dataUrl = canvas.toDataURL('image/png');

  // ניסיון שיתוף נייטיב (מובייל)
  if (navigator.canShare) {
    try {
      const blob = await (await fetch(dataUrl)).blob();
      const file = new File([blob], filename, { type: 'image/png' });
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title });
        return 'shared';
      }
    } catch (e) {
      // נופל להורדה
    }
  }
  // הורדה רגילה
  const link = document.createElement('a');
  link.download = filename;
  link.href = dataUrl;
  link.click();
  return 'downloaded';
}

// ייצוא אלמנט DOM ל-PDF (A4) עם כותרת ממותגת + טבלת סיכום אופציונלית
export async function exportElementAsPdf(element, { filename = 'tennis-report.pdf', title = 'טניס פרו ישראל', subtitle = '', summaryElement = null } = {}) {
  const pdf = new jsPDF('p', 'mm', 'a4');
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();
  const margin = 6;

  // כותרת ממותגת (פס ירוק עליון)
  const headerH = 22;
  pdf.setFillColor(16, 185, 129); // emerald-500
  pdf.rect(0, 0, pageW, headerH, 'F');
  pdf.setTextColor(255, 255, 255);
  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(16);
  pdf.text('TENNIS PRO ISRAEL', pageW / 2, 10, { align: 'center' });
  pdf.setFontSize(10);
  pdf.setFont('helvetica', 'normal');
  const headerSub = subtitle ? `${title}  |  ${subtitle}` : title;
  pdf.text(headerSub, pageW / 2, 17, { align: 'center' });

  let cursorY = headerH + 4;

  // טבלת סיכום (פודיום + פרסים) - נצרבת כתמונה (תמיכה מלאה בעברית)
  if (summaryElement) {
    const sumCanvas = await captureCanvas(summaryElement, '#ffffff');
    const sumW = pageW - margin * 2;
    const sumH = (sumCanvas.height * sumW) / sumCanvas.width;
    pdf.addImage(sumCanvas.toDataURL('image/png'), 'PNG', margin, cursorY, sumW, sumH);
    cursorY += sumH + 6;
  }

  // תמונת הברקט
  const canvas = await captureCanvas(element, '#ffffff');
  const imgData = canvas.toDataURL('image/png');
  const imgW = pageW - margin * 2;
  const imgH = (canvas.height * imgW) / canvas.width;
  const availableH = pageH - cursorY - margin;

  if (imgH <= availableH) {
    pdf.addImage(imgData, 'PNG', margin, cursorY, imgW, imgH);
  } else {
    // אם הברקט גבוה מהמקום שנותר - התחל בעמוד חדש
    if (cursorY > headerH + 8) {
      pdf.addPage();
      cursorY = margin;
    }
    let heightLeft = imgH;
    let position = cursorY;
    pdf.addImage(imgData, 'PNG', margin, position, imgW, imgH);
    heightLeft -= (pageH - cursorY - margin);
    while (heightLeft > 0) {
      position = margin - (imgH - heightLeft);
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', margin, position, imgW, imgH);
      heightLeft -= (pageH - margin * 2);
    }
  }

  // כותרת תחתונה
  pdf.setTextColor(150, 150, 150);
  pdf.setFontSize(8);
  pdf.text('tennisproisrael.co.il', pageW / 2, pageH - 4, { align: 'center' });

  pdf.save(filename);
}
